export enum LoaderStatus {
  pending = 'pending',
  stopped = 'stopped'
}
